import DialogContent from './content';
import DialogFooter from './footer';
import DialogHeader from './header';
import DialogWrapper from './wrapper';

const DialogLayout = {
  Wrapper: DialogWrapper,
  Header: DialogHeader,
  Content: DialogContent,
  Footer: DialogFooter,
};

export default DialogLayout;
